import { appDataReducerPaginationAndSearch } from './reducerMetadata';

export function AppDataReducerRunningTasks(state, action) {
    return {
        meta: appDataReducerPaginationAndSearch(action.runningTasks.message.meta),
        items: action.runningTasks.message.data.map((task) => ({
            id: task.id,
            taskType: task.task_type.name,
            administration: task.administration_name,
            cronExpression: task.cron_expression,
            nextExecutionAt: task.next_execution_at,
            timeout: task.timeout,
        })),
    };
}

export function AppDataReducerJobsOverview(state, action) {
    return {
        meta: appDataReducerPaginationAndSearch(action.jobsOverview.message.meta),
        items: action.jobsOverview.message.data.map((jobOverview) => ({
            id: jobOverview.queue_name + '-' + jobOverview.type, // Create an internal id, {queue, type} is unique
            queueName: jobOverview.queue_name,
            type: jobOverview.type,
            total: jobOverview.total,
            minCreatedAt: jobOverview.min_created_at,
            maxCreatedAt: jobOverview.max_created_at,
        })),
    };
}

export function AppDataReducerFailedJobs(state, action) {
    return {
        meta: appDataReducerPaginationAndSearch(action.failedJobs.message.meta),
        items: action.failedJobs.message.data.map((failedJob) => ({
            id: failedJob.id,
            queueName: failedJob.queue_name,
            payload: failedJob.payload,
            exception: failedJob.exception,
            failedAt: failedJob.failed_at,
        })),
    };
}
